(() => {
  const surfaces = '.directory-card,.category>div,.slide-dots button,.glass-nav-pill,.product,.add-button,.pdp-add,.glass-icon,.menu-toggle,.wish-button,.pack-choice,.search,.pdp-quantity,.quantity-stepper,.glass-cart-notice,.glass-notice-view,.product select,.product-filters button,.cart-control,#collection-filter-open,#collection-sort';
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  let frame = 0, point;
  function reset(element) {
    element.classList.remove('glass-tracking');
    ['--glass-x','--glass-y','--glass-rx','--glass-ry'].forEach(key => element.style.removeProperty(key));
    active.delete(element);
  }
  function clear() {
    if (frame) cancelAnimationFrame(frame);
    frame = 0; point = null;
    [...active].forEach(reset);
  }
  function render() {
    frame = 0;
    if (!point || reduced.matches || !fine.matches) return clear();
    const next = new Set();
    let element = point.target.closest?.(surfaces);
    while (element) {
      if (element.matches(':disabled,[aria-disabled="true"]')) {
        reset(element);
        element = element.parentElement?.closest(surfaces);
        continue;
      }
      next.add(element);
      const box = element.getBoundingClientRect();
      if (box.width && box.height) {
        const x = Math.max(0, Math.min(1, (point.x - box.left) / box.width));
        const y = Math.max(0, Math.min(1, (point.y - box.top) / box.height));
        element.style.setProperty('--glass-x', (x * 100) + '%');
        element.style.setProperty('--glass-y', (y * 100) + '%');
        if (element.matches('.product,.directory-card')) {
          element.style.setProperty('--glass-rx', ((.5 - y) * 5) + 'deg');
          element.style.setProperty('--glass-ry', ((x - .5) * 5) + 'deg');
        }
        element.classList.add('glass-tracking');
        active.add(element);
      }
      element = element.parentElement?.closest(surfaces);
    }
    [...active].forEach(item => { if (!next.has(item)) reset(item); });
  }
  document.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse' || reduced.matches || !fine.matches) return;
    point = { target:event.target, x:event.clientX, y:event.clientY };
    if (!frame) frame = requestAnimationFrame(render);
  }, {passive:true});
  document.addEventListener('pointerout', event => {
    if (frame) cancelAnimationFrame(frame);
    frame = 0; point = null;
    [...active].forEach(element => {
      if (!event.relatedTarget || !element.contains(event.relatedTarget)) reset(element);
    });
    if (!event.relatedTarget) clear();
  }, {passive:true});
  window.addEventListener('blur', clear);
  window.addEventListener('scroll', clear, {passive:true});
  document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); });
  fine.addEventListener('change', clear);
  reduced.addEventListener('change', clear);
})();